import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const CTA_LINK = 'https://mareaa.online/checkout/v3/start/1972060668/25acb4abfe837a80a6772bcc7e308b2d3875c2d2?from_store=1&country=AR';
export function SolutionSection() {
  return <section className="w-full bg-gradient-to-br from-primary to-primary-mid py-16 px-4 md:px-8" data-id="element-206">
      <div className="max-w-3xl mx-auto text-white" data-id="element-207">
        <motion.div initial={{
        opacity: 0,
        y: 25
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-208">
          <p className="text-white/60 text-sm uppercase tracking-wider mb-3" data-id="element-209">
            📖 La Solución
          </p>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif mb-4 text-white" data-id="element-210">
            Te presento el Ebook "Cero Inflamación"
          </h2>

          <p className="text-lg text-white/80 mb-4 max-w-xl mx-auto" data-id="element-211">
            La guía práctica para desinflamar tu abdomen, mejorar tu digestión y
            sentirte liviana en pocos días.
          </p>

          <p className="text-white/70 mb-8 max-w-xl mx-auto text-sm md:text-base" data-id="element-212">
            Esta guía combina alimentación antiinflamatoria, hábitos digestivos
            y estrategias prácticas para ayudarte a reducir la inflamación desde
            la raíz.
          </p>

          <p className="text-white/70 mb-8 max-w-lg mx-auto text-sm" data-id="element-213">
            Una guía simple, directa y sin vueltas que te explica exactamente
            qué hacer, cómo hacerlo y por qué funciona.
          </p>

          <div className="space-y-3 mb-8 text-left max-w-md mx-auto" data-id="element-214">
            <p className="flex items-start gap-2 text-white/90 text-sm" data-id="element-215">
              <span className="mt-0.5" data-id="element-216">👉</span> No es una dieta más
            </p>
            <p className="flex items-start gap-2 text-white/90 text-sm" data-id="element-217">
              <span className="mt-0.5" data-id="element-218">👉</span> No es dejar de comer todo
            </p>
            <p className="flex items-start gap-2 text-white/90 text-sm font-semibold" data-id="element-219">
              <span className="mt-0.5" data-id="element-220">👉</span> Es entender tu cuerpo y atacar
              la causa real
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-5 rounded-xl mb-8 max-w-md mx-auto text-left" data-id="element-221">
            <div className="space-y-2" data-id="element-222">
              <p className="flex items-start gap-2 text-white text-sm" data-id="element-223">
                <span className="text-accent-light mt-0.5" data-id="element-224">✓</span> Guía paso a
                paso fácil de aplicar
              </p>
              <p className="flex items-start gap-2 text-white text-sm" data-id="element-225">
                <span className="text-accent-light mt-0.5" data-id="element-226">✓</span> Enfoque
                práctico desde el primer día
              </p>
              <p className="flex items-start gap-2 text-white text-sm" data-id="element-227">
                <span className="text-accent-light mt-0.5" data-id="element-228">✓</span> Diseñada
                para mujeres que ya probaron de todo
              </p>
            </div>
          </div>

          <motion.a href={CTA_LINK} onClick={trackAddToCart} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-flex items-center gap-3 bg-accent hover:bg-accent/90 text-white font-bold text-base md:text-lg px-10 py-5 rounded-full shadow-xl shadow-accent/30 transition-all duration-300" data-id="element-229">
            QUIERO SENTIRME MEJOR CON MI CUERPO
            <ArrowRightIcon className="w-5 h-5" data-id="element-230" />
          </motion.a>
        </motion.div>
      </div>
    </section>;
}